(()=>{
  'use strict';
  if(window.yayaRecentlyViewedLoaded)return;
  const configNode=document.getElementById('yaya-recent-config');
  if(!configNode)return;
  window.yayaRecentlyViewedLoaded=true;
  configNode.dataset.recentStatus='starting';
  const config=JSON.parse(configNode.textContent),key='yaya:recently-viewed:v1',ttl=30*86400000;
  const section=document.getElementById('yaya-recently-viewed');
  const track=section?.querySelector('[data-recent-track]');
  let generation=0,recorded=false;
  function allowed(){try{return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed()===true}catch{return false}}
  function read(){try{
    const data=JSON.parse(localStorage.getItem(key)||'[]');
    if(!Array.isArray(data))return [];
    const seen=new Set();
    return data.filter(x=>x&&typeof x.handle==='string'&&/^[a-z0-9][a-z0-9-]{0,254}$/.test(x.handle)&&Number.isFinite(x.at)&&x.at<=Date.now()+60000&&Date.now()-x.at<ttl&&!seen.has(x.handle)&&seen.add(x.handle)).slice(0,20);
  }catch{return []}}
  function write(items){try{localStorage.setItem(key,JSON.stringify(items))}catch{}}
  function clear(){try{localStorage.removeItem(key)}catch{}if(section){section.hidden=true;track?.replaceChildren()}}
  function card(product){
    const article=document.createElement('article');article.className='yaya-recent-card';
    const link=document.createElement('a');link.href=config.root+'products/'+encodeURIComponent(product.handle);
    const imageWrap=document.createElement('div');imageWrap.className='yaya-recent-photo';
    if(product.featured_image){
      const url=new URL(product.featured_image.startsWith('//')?'https:'+product.featured_image:product.featured_image,location.origin);
      if(url.protocol==='https:'){
        url.searchParams.set('width','640');
        const img=document.createElement('img');img.src=url.href;img.alt=product.title;img.loading='lazy';img.decoding='async';img.width=640;img.height=640;imageWrap.append(img);
      }
    }
    const name=document.createElement('h3');name.textContent=product.title;
    const price=document.createElement('p');price.className='yaya-recent-price';
    const currency=window.Shopify?.currency?.active||config.currency;
    const formatter=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency,maximumFractionDigits:2,minimumFractionDigits:0});
    price.textContent=(product.price_varies?'From ':'')+formatter.format(product.price/100);
    link.append(imageWrap,name,price);article.append(link);return article;
  }
  function controls(){
    if(!track)return;
    const prev=section.querySelector('[data-recent-prev]'),next=section.querySelector('[data-recent-next]');
    function update(){const overflow=track.scrollWidth>track.clientWidth+2;prev.hidden=next.hidden=!overflow;prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2}
    [prev,next].forEach((button,index)=>button.addEventListener('click',()=>track.scrollBy({left:(index?1:-1)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));
    track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
  }
  async function run(){
    const current=++generation;
    if(!allowed()){configNode.dataset.recentStatus='consent-blocked';recorded=false;clear();return}
    let items=read();
    if(config.handle&&!recorded){recorded=true;items=[{handle:config.handle,at:Date.now()},...items.filter(x=>x.handle!==config.handle)].slice(0,20);write(items)}
    configNode.dataset.recentStatus=config.handle?'recorded':items.length?'loading':'empty';
    if(!section||!track||!items.length){if(section)section.hidden=true;return}
    const results=await Promise.all(items.slice(0,8).map(async item=>{
      try{const response=await fetch(config.root+'products/'+encodeURIComponent(item.handle)+'.js',{credentials:'same-origin'});if(!response.ok)return null;const product=await response.json();return product.handle&&product.title&&Number.isFinite(product.price)?product:null}catch{return null}
    }));
    if(current!==generation||!allowed())return;
    const products=results.filter(Boolean);if(!products.length){section.hidden=true;return}
    track.replaceChildren(...products.map(card));section.hidden=false;configNode.dataset.recentStatus='rendered';
  }
  controls();
  document.addEventListener('visitorConsentCollected',run);
  document.addEventListener('consentTrackingApiLoaded',run);
  window.addEventListener('load',()=>{if(typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed==='function')run()},{once:true});
  window.addEventListener('storage',event=>{if(event.key===key)run()});
  window.addEventListener('pageshow',event=>{if(event.persisted)run()});
  if(typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed==='function')run();
  else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{if(!error)run()});
})();
